window.theme = window.theme || {};

const header = document.querySelector("sticky-header");

theme.utils = {
    /**
     * JSON.parse but deals with undefined/nulls.
     */
    parseJSON(
        value,
        ignoreError = false
    ){
        if (!value) return null
        if (typeof value === 'number') return value
        if (typeof value === 'boolean') return value

        try {
            return JSON.parse(value)
        } catch (e) {
            if (ignoreError) {
                console.warn(e);
                return null
            }
            throw e
        }
    },

    getHeaderHeight(){
        return header.scrollHeight;
    }
}